import React from 'react';
import { InjectedTranslateProps } from 'react-i18next';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';

import styles from './GogWrapper.st.css';
import Gog from './GogOOI/Gog';
import { parseAlbumsCovers } from '../../../services/gogHelper';

const orderIndexSorter = function (a: GalleryItem, b: GalleryItem) {
  return a.orderIndex > b.orderIndex ? 1 : -1;
};

type GogWrapperProps = InjectedExperimentsProps &
  InjectedTranslateProps &
  WidgetProps;

export class GogWrapper extends React.Component<
  GogWrapperProps,
  GogWrapperState
> {
  shouldUseImageToken: boolean;

  constructor(props: GogWrapperProps) {
    super(props);
    this.state = {
      gogData: props.gogData,
      albumsCovers: props.albumsCovers.sort(orderIndexSorter),
      coverIdToAlbum: props.coverIdToAlbum,
    };
    this.handleWixEvent = this.handleWixEvent.bind(this);
    this.shouldUseImageToken = props.experiments.enabled(
      'specs.albums.useWatermarkImageToken',
    );
  }

  handleWixEvent(event: any) {
    if (event.action === 'albumsData') {
      try {
        const gogAlbums: GogAlbum[] = event.data;
        const { albumsCovers, coverIdToAlbum } = parseAlbumsCovers(
          gogAlbums,
          this.shouldUseImageToken,
        );
        albumsCovers.sort(orderIndexSorter);
        this.setState({
          gogData: { ...this.state.gogData, albums: gogAlbums },
          albumsCovers,
          coverIdToAlbum,
        });
      } catch (e) {
        console.error('Failed to update gog ' + e);
      }
    }
  }

  componentDidMount() {
    if (this.props.viewMode === 'Editor') {
      this.props.Wix &&
        this.props.Wix.addEventListener(
          this.props.Wix.Events.SETTINGS_UPDATED,
          this.handleWixEvent,
        );
    }
  }

  render() {
    const { t, experiments, host, ...rest } = this.props;

    const styleParams = this.props.host.style.styleParams;

    const gogProps = {
      ...this.props,
      pageId: this.props.host.pageId,
      compId: this.props.host.id,
      dimensions: this.props.host.dimensions,
      styleParams,
      textPresets: this.props.host.style.siteTextPresets,
      gogData: this.state.gogData,
      albumsCovers: this.state.albumsCovers,
      coverIdToAlbum: this.state.coverIdToAlbum,
    };

    return (
      <div {...styles('root', {}, rest)} data-hook="AlbumsGOGOOI-wrapper">
        <Gog {...gogProps} />
      </div>
    );
  }
}

export default withExperiments<GogWrapperProps>(GogWrapper);
